module.exports = __webpack_public_path__ + "static/media/dec-tutorial-selfie.26662fe7.gif";